import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ClerkService } from 'ngx-clerk-iliad';
import { AlertController } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private router = inject(Router);
  private clerkService = inject(ClerkService);
  private alertController = inject(AlertController);

  /**
   * Shows a confirmation dialog and logs out the user if confirmed
   */
  async confirmAndLogout(): Promise<void> {
    const alert = await this.alertController.create({
      header: 'Confirm Logout',
      message: 'Are you sure you want to log out?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Logout',
          role: 'confirm',
          handler: () => {
            this.logout();
          }
        }
      ]
    });

    await alert.present();
  }

  /**
   * Logs out the user, clears state, and redirects to the login page
   */
  async logout(): Promise<void> {
    try {
      // Sign out from Clerk by subscribing to clerk$ and using the first Clerk instance
      this.clerkService.clerk$.subscribe(async (clerk) => {
        if (clerk) {
          // Use the signOut method on the Clerk instance
          await clerk.signOut();

          // Clear any local storage data if needed
          localStorage.removeItem('user_settings');

          // Redirect to the login page
          this.router.navigate(['/auth/sign-in']);

          // Reload the page to ensure complete state reset
          setTimeout(() => {
            window.location.reload();
          }, 100);
        }
      });
    } catch (error) {
      console.error('Error during logout:', error);
    }
  }
}
